import {Injectable} from '@angular/core';
import {chunk} from 'lodash-es';
import {Page} from '@uofu-uss/angular-util';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor() {
  }

  mapDataToPages<PageType>(allData: ReadonlyArray<PageType>, pageSize = 25): ReadonlyArray<Page<PageType>> {
    const chunks = chunk(allData, pageSize);
    return chunks.map((arr, i) => {
      return {
        data: arr,
        size: arr.length,
        number: i,
        totalElements: allData.length,
        totalPages: chunks.length,
      };
    });
  }

}
